import { Components, Theme } from '@mui/joy';

export const JoyRadioConfig: Partial<Components<Theme>> = {
  JoyRadio: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          '&.invalid .MuiCheckbox-checkbox': {
            borderColor: theme.palette.danger['500'],
          },
        };
      },
      radio: ({ theme, ownerState }) => {
        return {
          borderWidth: '2px',
          borderColor: theme.palette.neutral['600'],
          color: theme.palette.common.white,
          ...(ownerState.checked && {
            color: theme.palette.primary['500'],
            borderColor: theme.palette.primary['500'],
            '&:hover': {
              color: theme.palette.neutral['800'],
              borderColor: theme.palette.neutral['800'],
            },
          }),
        };
      },
    },
  },
};
